function e(t){return typeof t=="object"&&t!==null}export{e as isObjectLike};
